import React, { useEffect, useState } from 'react';
import { hämtaKundHistorik, Händelse } from '../api/client';
import { TEMA } from '../theme';

const VISA_FÖRST = 5;

// "i dag 11:12", "i går 14:03", annars "24 sep 09:10".
function närText(tid: string): string {
  const d = new Date(tid);
  const klocka = d.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' });
  const idag = new Date();
  const igår = new Date(); igår.setDate(idag.getDate() - 1);
  const sammaDag = (a: Date, b: Date) => a.toDateString() === b.toDateString();
  if (sammaDag(d, idag)) return `i dag ${klocka}`;
  if (sammaDag(d, igår)) return `i går ${klocka}`;
  const datum = d.toLocaleDateString('sv-SE', { day: 'numeric', month: 'short' }).replace('.', '');
  return `${datum} ${klocka}`;
}

/** Vem som gjort vad med kunden, nyast först. Hämtar sina egna data. */
export default function KundHistorik({ kundId }: { kundId: string }) {
  const [rader, setRader] = useState<Händelse[] | null>(null);
  const [visaAlla, setVisaAlla] = useState(false);

  useEffect(() => {
    let avbruten = false;
    setRader(null);
    setVisaAlla(false);
    hämtaKundHistorik(kundId)
      .then(res => { if (!avbruten) setRader(res.data); })
      .catch(err => {
        console.error('Kunde inte hämta historiken:', err);
        if (!avbruten) setRader([]);
      });
    return () => { avbruten = true; };
  }, [kundId]);

  if (rader === null || rader.length === 0) return null;
  const synliga = visaAlla ? rader : rader.slice(0, VISA_FÖRST);

  return (
    <div style={{ marginTop: '36px' }}>
      <h2 style={{ margin: '0 0 12px', fontFamily: "'Fraunces', serif", fontSize: '20px', fontWeight: 400, color: TEMA.ink }}>
        Historik
      </h2>
      <div style={{ borderTop: `1px solid ${TEMA.border}` }}>
        {synliga.map((h, i) => (
          <div key={i} style={{
            display: 'flex', gap: '16px', alignItems: 'baseline', flexWrap: 'wrap',
            padding: '10px 0', borderBottom: `1px solid ${TEMA.border}`,
            fontFamily: "'Inter', sans-serif", fontSize: '13px',
          }}>
            <span style={{ color: TEMA.inkFaint, minWidth: '110px', fontFamily: "'IBM Plex Mono', monospace", fontSize: '12px' }}>
              {närText(h.tid)}
            </span>
            <span style={{ color: TEMA.inkSoft, minWidth: '70px' }}>{h.vem || 'Systemet'}</span>
            <span style={{ color: TEMA.ink, flex: 1 }}>{h.beskrivning}</span>
          </div>
        ))}
      </div>
      {rader.length > VISA_FÖRST && (
        <button
          onClick={() => setVisaAlla(v => !v)}
          style={{
            marginTop: '10px', background: 'none', border: 'none', padding: 0, cursor: 'pointer',
            fontFamily: "'Inter', sans-serif", fontSize: '12.5px', color: TEMA.inkFaint,
          }}
        >
          {visaAlla ? 'Visa färre' : `Visa alla (${rader.length})`}
        </button>
      )}
    </div>
  );
}
